import API from '@/api/api'

export default {
  // eslint-disable-next-line
  GET_LOGS ({}) {
    return API.GET.logs()
  }
}
